import { createSlice } from '@reduxjs/toolkit';
import type { RootState } from './store';
import { icons } from '@/components/Base/Lucide';

export interface Menu {
  icon: keyof typeof icons;
  title: string;
  badge?: number;
  pathname?: string;
  subMenu?: Menu[];
  ignore?: boolean;
}

export interface SideMenuState {
  menu: Array<Menu | string>;
}

const initialState: SideMenuState = {
  menu: [
    {
      icon: 'LayoutDashboard',
      pathname: '/',
      title: 'Dashboard',
    },
    {
      icon: 'Users',
      pathname: '/ambassador',
      title: 'Ambassador',
    },
    {
      icon: 'FileSpreadsheet',
      pathname: '/data-report',
      title: 'Survey Data',
    },
    {
      icon: 'ClipboardList',
      pathname: '/surveys',
      title: 'Survey Tracking',
    },
    {
      icon: 'QrCode',
      pathname: '/qr-tracking',
      title: 'QR Tracking',
    },
    {
      icon: 'UserCog',
      pathname: '/manage-users',
      title: 'Manage Users',
    },
    {
      icon: 'Globe',
      pathname: '/manage-site',
      title: 'Manage Site',
    },
    {
      icon: 'ScrollText',
      pathname: '/logs',
      title: 'Logs',
    },
  ],
};

export const sideMenuSlice = createSlice({
  name: 'sideMenu',
  initialState,
  reducers: {},
});

export const selectSideMenu = (state: RootState) => state.sideMenu.menu;

export default sideMenuSlice.reducer;
